module.exports = __webpack_public_path__ + "media/images/stat-longest-streak-dark-60b34422.svg";